<div style="width: 550px; height: 450px; " data-cy="ar-payment-token-consent">
  <!-- body -->
  <app-tdo-progress-spinner *ngIf="isLoading" class="spinner" data-cy="ar-payment-token-consent-spinner"></app-tdo-progress-spinner>
  <div class="section-header" style="flex-basis: 30px;" data-cy="ar-payment-token-consent-header">
    <div class="section-header-title" data-cy="ar-payment-token-consent-title">
      Today's Payment
    </div>
    <div style="flex: 1;" data-cy="ar-payment-token-consent-header-spacer"></div>
  </div>
  <p style="padding: 10px" data-cy="ar-payment-token-consent-description">
    First payment is necessary to initialize the payment plan.
    This payment is to provide verbal consent to use this payment method for all consequent payments listed in this agreement.
  </p>
  <mat-checkbox [(ngModel)]="verbalConsent" style="margin-bottom: 10px; padding: 10px" data-cy="ar-payment-token-consent-verbal-checkbox">
    Verbal Consent Given By
  </mat-checkbox>

  <div class="flexbox-container top-center-column" style="margin-left: 20px; " data-cy="ar-payment-token-consent-consent-container">

    <mat-radio-group [(ngModel)]="consentGivenBy" style="display: flex; flex-direction: column; margin-bottom: 10px;" data-cy="ar-payment-token-consent-consent-by-group">
      <mat-radio-button value="patient" data-cy="ar-payment-token-consent-patient-radio">Patient</mat-radio-button>
      <div style="display: flex; align-items: center; " data-cy="ar-payment-token-consent-contact-row">
        <mat-radio-button value="patientContact" style="margin-right: 20px " data-cy="ar-payment-token-consent-contact-radio">Patient Contact</mat-radio-button>
        <span style="margin-right: 20px" data-cy="ar-payment-token-consent-contact-name">{{this.patientContactName}}</span>
        <button class="tdo-button tdo-close" (click)="launchSubscriberManager()" data-cy="ar-payment-token-consent-select-contact-btn">Select</button>
      </div>
    </mat-radio-group>

    <mat-form-field data-cy="ar-payment-token-consent-expiration-field">
      <mat-label data-cy="ar-payment-token-consent-expiration-label">Consent Expiration Date</mat-label>
      <input matInput placeholder="MM-YYYY" [(ngModel)]="expirationDate" (input)="formatExpiryDate($event)" maxlength="7" data-cy="ar-payment-token-consent-expiration-input">
    </mat-form-field>

  </div>
  <div data-cy="ar-payment-token-consent-spacer"></div>
  <div class="flexbox-container top-center-column" style="margin-left: 20px; " data-cy="ar-payment-token-consent-payment-container">
    <span style="margin-right: 20px" data-cy="ar-payment-token-consent-amount">Amount: <strong data-cy="ar-payment-token-consent-amount-value">{{this.paymentAmount | currency:'USD'}}</strong></span>
    <button class="tdo-button tdo-close" (click)="chargePaymentButton()"
    [disabled]="!this.verbalConsent || !(this.expirationDate.length===7) || !!(this.consentGivenBy === 'patientContact' && !this.patientContactID)" data-cy="ar-payment-token-consent-charge-btn">Charge</button>
  </div>

  <!--  FOOTER-->
  <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="ar-payment-token-consent-footer">
    <div style="flex: 1; margin-right: 6px;" data-cy="ar-payment-token-consent-footer-spacer"></div>
    <button data-cy="ar-payment-token-consent-close-btn" (click)="close()" class="tdo-button tdo-close"
            style="margin-right: 10px;">Close</button>
  </div>
</div>
